import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFolder({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M20 18a1 1 0 0 1-.883.993L19 19H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4.63a2 2 0 0 1 1.341.515l.743.672a1 1 0 0 0 .67.257H19a1 1 0 0 1 1 1V18zm-1-8H5v8h14v-8zM9.63 6H5v3h14V7.444h-6.615a2 2 0 0 1-1.198-.398l-.143-.117-.743-.671A1 1 0 0 0 9.63 6z"/>
        </svg>
    );
}

export default IconFolder;

